module.exports = __webpack_public_path__ + "img/exam_jan_2025_5yc5rk6c.641cc8e6.jpg";